import { motion } from "framer-motion";
import SectionTitle, { SectionTitle1 } from "../General/SectionTitle";
import ServiceBubble from "../General/ServiceBubble/ServiceBubble";
import Design, { RealNotifications, SecureTransactions } from "./Design/Design";
import Innovation, { DataProtection, Regulated } from "./Innovation/Innovation";
import Security, { SafeGuard, TrustCompliance } from "./Security/Security";
import {
  ModuleContainer,
  ModuleContainer1,
  ValuesContainer,
  ValuesContainer1,
} from "./Values.styles";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLocale } from "../../../locales/localeSlice";

const FadeInAnimation = {
  initial: { y: "100%", opacity: 0 },
  animate: (index: number) => ({
    y: 0,
    opacity: 1,
    transition: { duration: 1.5, delay: 0.5 * index },
  }),
};

const ValuesandPrinciples = () => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  const values = [Innovation, Design, Security];

  return (
    <ValuesContainer>
      <ServiceBubble
        position="center"
        label="ETHICS AND VALUES"
        backgroundColor="rgba(0, 199, 3, 0.1)"
      />
      <SectionTitle
        label={t("EthicsValue.title", {
          lng: currentLocale,
        })}
      />

      <ModuleContainer>
        {values.map((Component, index) => (
          <motion.div
            key={index}
            variants={FadeInAnimation}
            initial="initial"
            whileInView="animate"
            custom={index}
            viewport={{ once: true }}
          >
            <Component />
          </motion.div>
        ))}
      </ModuleContainer>
    </ValuesContainer>
  );
};

export default ValuesandPrinciples;

export const ValuesandPrinciples1 = () => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  const values = [
    DataProtection,
    RealNotifications,
    TrustCompliance,
    Regulated,
    SecureTransactions,
    SafeGuard,
  ];

  return (
    <ValuesContainer1>
      <ServiceBubble
        position="center"
        label="SECURITY"
        backgroundColor="rgba(0, 199, 3, 0.1)"
      />
      <SectionTitle1
        label={t("SecurityPage.title", {
          lng: currentLocale,
        })}
      />

      <ModuleContainer1>
        {values.map((Component, index) => (
          <Component key={index} />
        ))}
      </ModuleContainer1>
    </ValuesContainer1>
  );
};
